<template>
  <div>
    <!-- Breadcrumb -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/admin/welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商城管理</el-breadcrumb-item>
      <el-breadcrumb-item>商品订单列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Card -->
    <el-card>
      <!-- Search Area -->
      <div class="search-wrapper">
        <div class="search-toggle" @click="toggleSearch" v-show="isMobile">
          <i :class="isSearchExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          <span>{{ isSearchExpanded ? '收起筛选' : '展开筛选' }}</span>
        </div>
        <div class="search-content" v-show="!isMobile || isSearchExpanded" :class="{ 'search-content-mobile': isMobile }">
          <el-row :gutter="10">
            <el-col :span="6">
              <el-input 
                placeholder="订单编号" 
                v-model="searchQuery.order_no" 
                clearable 
                @clear="handleSearch()"
                @keyup.enter.native="handleSearch()"
                size="medium">
                <el-button slot="append" icon="el-icon-search" @click="handleSearch()"></el-button>
              </el-input>
            </el-col>
            <el-col :span="6">
              <el-input 
                placeholder="商品名称" 
                v-model="searchQuery.title_cn" 
                clearable 
                @clear="handleSearch()" 
                @keyup.enter.native="handleSearch()"
                size="medium">
                <el-button slot="append" icon="el-icon-search" @click="handleSearch()"></el-button>
              </el-input>
            </el-col>
            <el-col :span="4">
              <el-select v-model="searchQuery.status" placeholder="订单状态" @change="handleSearch()" size="medium">
                <el-option :value="0" label="待支付"></el-option>
                <el-option :value="1" label="已支付"></el-option>
                <el-option :value="2" label="已取消"></el-option>
                <el-option :value="3" label="已退款"></el-option>
              </el-select>
            </el-col>
            <el-col :span="4">
              <el-select v-model="searchQuery.shipping_status" placeholder="发货状态" @change="handleSearch()" size="medium">
                <el-option :value="0" label="待发货"></el-option>
                <el-option :value="1" label="已发货"></el-option>
                <el-option :value="2" label="已送达"></el-option>
                <el-option :value="3" label="已退货"></el-option>
              </el-select>
            </el-col>
            <el-col :span="4">
              <el-button type="default" @click="resetSearch()" size="medium">重置</el-button>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- Order List -->
      <div class="table-scroll-wrapper">
        <el-table :data="orderList" style="width: 100%" border stripe>
        <el-table-column label="#" type="index" width="40" align="center"></el-table-column>
        <el-table-column label="订单编号" prop="order_no" align="center"></el-table-column>
        <el-table-column label="商品名称" prop="title_cn" align="center"></el-table-column>
        <el-table-column label="购买件数" width="80" prop="quantity" align="center"></el-table-column>
        <el-table-column label="订单金额" width="100" align="center">
          <template slot-scope="scope">¥{{ scope.row.amount }}</template>
        </el-table-column>
        <el-table-column label="需要发货" width="80" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.need_addr === true" type="info">需要</div>
            <div v-else type="info">不需要</div>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="created_at" width="150" align="center"></el-table-column>
        <el-table-column label="订单状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.status)">
              {{ getStatusText(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="发货状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="getShippingStatusType(scope.row.shipping_status)">
              {{ getShippingStatusText(scope.row.shipping_status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" align="center">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click="viewOrder(scope.row.order_no)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      </div>

      <!-- Pagination -->
      <div class="pagination-wrapper">
        <el-pagination
          @size-change="onSizeChange"
          @current-change="onPageChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          :layout="isMobile ? 'total, sizes, prev, pager, next' : 'total, sizes, prev, pager, next, jumper'"
          :total="total">
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import filterMixin from '@/utils/filter.js'

export default {
  name: 'ShopOrders',
  mixins: [filterMixin],
  data() {
    return {
      isSearchExpanded: false,
      isMobile: false,
      sessionKey: 'ShopOrdersSearch',
      filterFetchMethod: 'fetchOrders',
      total: 0,
      pageNum: 1,
      pageSize: 10,
      orderList: [],
      searchQuery: {
        order_no: '',
        title_cn: '',
        status: null,
        shipping_status: null
      },
      statusInfo: {
        0: { type: 'danger', text: '待支付' },
        1: { type: 'primary', text: '已支付' },
        2: { type: 'info', text: '已取消' },
        3: { type: 'warning', text: '已退款' }
      },
      shippingStatusInfo: {
        0: { type: 'warning', text: '待发货' },
        1: { type: 'success', text: '已发货' },
        2: { type: 'primary', text: '已送达' },
        3: { type: 'info', text: '已退货' }
      }
    }
  },
  created() {
    this.fetchOrders()
    this.checkIsMobile()
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    fetchOrders() {
      this.$http({
        method: 'get',
        url: 'shop-orders/',
        params: {
          ...this.searchQuery,
          page: this.pageNum,
          size: this.pageSize
        }
      }).then(res => {
        if (!res.success) return this.$message.error(res.message)
        this.orderList = res.data
        this.total = res.total
      }).catch(err => {
        this.$message.error(err.response?.data?.message || '获取订单列表失败')
      })
    },

    handleSearch() {
      this.pageNum = 1
      this.fetchOrders()
    },

    resetSearch() {
      this.searchQuery = { order_no: '', title_cn: '', status: null, shipping_status: null }
      this.pageNum = 1
      this.pageSize = 10
      sessionStorage.removeItem(this.sessionKey)
      this.fetchOrders()
    },

    getStatusText(status) {
      return this.statusInfo[status]?.text || '未知'
    },

    getStatusType(status) {
      return this.statusInfo[status]?.type || 'info'
    },

    getShippingStatusText(status) {
      return this.shippingStatusInfo[status]?.text || '未知'
    },

    getShippingStatusType(status) {
      return this.shippingStatusInfo[status]?.type || 'info'
    },

    onSizeChange(newSize) {
      this.pageSize = newSize
      this.fetchOrders()
    },

    onPageChange(newPage) {
      this.pageNum = newPage
      this.fetchOrders()
    },

    viewOrder(orderNo) {
      this.$router.push(`/admin/shop/order-details/${orderNo}`)
    },

    toggleSearch() {
      this.isSearchExpanded = !this.isSearchExpanded
    },
    checkIsMobile() {
      this.isMobile = window.innerWidth <= 768
    },
    handleResize() {
      this.checkIsMobile()
    }
  }
}
</script>

<style scoped>
.el-card {
  margin-top: 15px;
}

.table-scroll-wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  margin-top: 15px;
}

.table-scroll-wrapper .el-table {
  min-width: 100%;
}

.pagination-wrapper {
  margin-top: 15px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  touch-action: pan-x;
}

.pagination-wrapper .el-pagination {
  display: flex;
  justify-content: center;
  flex-wrap: nowrap;
  padding: 10px 0;
  min-width: max-content;
}

.search-wrapper {
  margin-bottom: 10px;
}

.search-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  color: #666;
  font-size: 14px;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
  transition: color 0.3s;
}

.search-toggle:hover {
  color: #409eff;
}

.search-toggle i {
  font-size: 14px;
}

.search-content {
  padding-top: 10px;
}

.search-content-mobile {
  padding-top: 10px;
}

@media (max-width: 768px) {
  .el-card {
    margin-top: 10px;
    padding: 10px;
  }

  .el-table {
    margin-top: 10px;
    font-size: 11px;
    overflow-x: auto;
    display: block;
  }

  .el-table th,
  .el-table td {
    padding: 8px 5px !important;
  }

  .el-table .el-button--small {
    font-size: 11px;
  }

  .el-pagination {
    margin-top: 10px;
    font-size: 11px;
  }

  .el-pagination .el-pagination__sizes {
    display: none;
  }

  .el-pagination .btn-prev,
  .el-pagination .btn-next {
    width: 30px;
    height: 30px;
    line-height: 30px;
  }

  .el-pagination .el-pager li {
    padding: 0 4px;
    min-width: 28px;
    height: 30px;
    line-height: 30px;
  }

  .search-content .el-row {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .search-content .el-row .el-col {
    width: 100% !important;
    margin-bottom: 5px;
  }

  .search-toggle {
    padding: 10px 0;
    font-size: 13px;
  }
}
</style>
